import {Component, ElementRef, HostBinding, Input} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {SelectOption} from '@catuiform/types';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'modal-multi-select';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

interface CheckboxItem {
  selected: boolean;
  label: string;
}

@Component({
  selector: 'cat-modal-multi-select',
  templateUrl: './modal-multi-select.component.html',
  styleUrls: ['./modal-multi-select.component.scss'],
})
export class ModalMultiSelectComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() title: string;

  @Input()
  get options(): SelectOption[] {
    return this._options;
  }

  set options(values: SelectOption[]) {
    this._options = values;
    this.initSelectOptionUpdate();
  }

  @Input()
  get values(): any[] {
    return this._values;
  }

  set values(values: any[]) {
    this._values = values;
    this.initSelectOptionUpdate();
  }

  _options: SelectOption[];
  _values: any[];

  form: FormGroup;

  constructor(public el: ElementRef,
              private formBuilder: FormBuilder,
              public activeModal: ActiveModal) {
    this.form = this.formBuilder.group({
      items: this.formBuilder.array([]),
    });
  }

  private initSelectOptionUpdate() {
    if (!isNullOrUndefined(this.options) && !isNullOrUndefined(this.values)) {
      this.updateSelectOptions();
    }
  }

  private updateSelectOptions() {
    const items: FormGroup[] = [];

    this.options.forEach((option: SelectOption) => {
      items.push(this.formBuilder.group({label: option.label, selected: false, value: option}));
    });
    this.form.setControl('items', this.formBuilder.array(items));
  }

  updateForm() {
    this.activeModal.close(
      this.form.value.items
      .filter((item) => item.selected)
      .map((item) => item.value));
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-form/components/modal-multi-select/modal-multi-select.component.ts